import { render, staticRenderFns } from "./HSCodeListEdit.vue?vue&type=template&id=2e4fb312&scoped=true"
import script from "./HSCodeListEdit.vue?vue&type=script&lang=js"
export * from "./HSCodeListEdit.vue?vue&type=script&lang=js"
import style0 from "./HSCodeListEdit.vue?vue&type=style&index=0&id=2e4fb312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4fb312",
  null
  
)

export default component.exports